import { Auth } from 'aws-amplify';

import ROUTE_NAMES from '@/assets/src/routes';
import { setCredentialsInStore, setUserInStore } from '@/assets/src/amplify/helpers';

const AuthRouter = {
  path: '/auth/',
  name: 'auth',
  component: () => import(/* webpackChunkName: "AuthView" */ '@/views/AuthView.vue'),
  children: [
    {
      path: 'signin',
      name: ROUTE_NAMES.AUTH_SIGNIN,
      component: () => import(/* webpackChunkName: "AuthSignIn" */ '@/views/auth/AuthSignIn.vue'),
    },
    {
      path: 'forgot',
      name: ROUTE_NAMES.AUTH_FORGOT_PASSWORD,
      component: () => import(/* webpackChunkName: "AuthForgotPassword" */ '@/views/auth/AuthForgotPassword.vue'),
    },
  ],
};

const AuthFilter = (to: any, from: any, next: any) => {
  Promise.all([Auth.currentAuthenticatedUser(), Auth.currentCredentials()])
    .then(([user, credentials]) => {
      setUserInStore(user);
      setCredentialsInStore(credentials);
      next();
    })
    .catch(() => {
      setUserInStore(null);
      setCredentialsInStore(null);
      if (!to.path.startsWith('/auth')) {
        next({ name: ROUTE_NAMES.AUTH_SIGNIN });
      } else {
        next();
      }
    });
};

export { AuthRouter, AuthFilter };
